<div (click)="ref$() ? op.show($event, ref$()) : undefined"
     class="w-full bg-[#F9F9F9] rounded-xl text-red-500 flex flex-row items-center gap-1 px-2">
  <sens-icon [size]="20" icon="#icon-search" class="basis-5 shrink-0"/>
  <input #inputSearch
         (input)="onSearchInput($event)"
         (keyup.enter)="onSearchKeydown(inputSearch.value)"
         class="w-full text-sm/5! py-2 outline-0"
         type="text" autocomplete="off" placeholder="Search Sens Content" [value]="queryParams()?.['q'] ?? ''">
  @if (!!inputSearch.value) {
    <button type="button" (click)="inputSearch.value = '';onSearchClear()"
            class="text-sm/5! cursor-pointer"
    >Clear</button>
  }
</div>

<p-popover #op>
  <div (click)="op.toggle($event)"
    class="rounded-[0_0_20px_20px] px-3 py-3 bg-white h-fit w-[700px] max-w-dvw max-h-[calc(100dvh-60px)] overflow-y-auto">

    @if (isLoading()) {
      <p class="text-sm/5 font-bold">Loading...</p>
    } @else {
      @if (!!faps$().length) {
        <p class="font-bold mb-2 text-sm/5">Newest for you:</p>
        <div class="grid grid-cols-2 min-[1000px]:grid-cols-4 gap-0.5 mb-2">
          @for (item of faps$(); track item.fap_id) {
            <a [routerLink]="['/faps', item.fap_id]" class="bg-gray-500 rounded-xl overflow-hidden h-[300px] min-[1000px]:h-[265px] relative">
              <img [src]="item.preview_url" class="h-full w-full object-cover" alt="">
              <div class="h-10 absolute bottom-0 left-0 z-1 w-full
                      bg-linear-[180deg,#18181900_5%,#181819B2_60%,#181819_100%]
                      flex items-center flex-row justify-end px-3">
                <p class="flex flex-row items-center gap-1 text-white font-bold text-xs/4">
                  <sens-icon [size]="16" icon="#icon-view"/>
                  {{item?.views}}
                </p>
              </div>

            </a>
          }
        </div>

        <div class="text-center">
          <a [routerLink]="['/search']" [queryParams]="{q: inputSearch.value}"
             class="text-red-500! text-sm/5 font-bold">View All</a>
        </div>

      } @else {
        <p class="text-sm/5 font-bold">No results found</p>
      }
    }

  </div>
</p-popover>
